<template>
  <div class="cleo-working-frame flex items-center gap-2.5 px-4 py-2.5">
    <span class="cleo-working-orb shrink-0" />
    <Transition name="cleo-phrase" mode="out-in">
      <span :key="phraseIdx" class="cleo-working-shimmer text-xs font-semibold whitespace-nowrap">{{ phrases[phraseIdx] }}</span>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

const phrases = [
  'Reading your message…',
  'Thinking it through…',
  'Rounding up the right specialists…',
  'Checking your live OneClick data…',
  'Connecting the dots…',
];

const phraseIdx = ref(0);
let rotateTimer: ReturnType<typeof setInterval> | null = null;

onMounted(() => {
  rotateTimer = setInterval(() => {
    phraseIdx.value = (phraseIdx.value + 1) % phrases.length;
  }, 2400);
});

onUnmounted(() => {
  if (rotateTimer) clearInterval(rotateTimer);
});
</script>

<style scoped>
.cleo-working-frame {
  display: inline-flex;
  border-radius: 16px;
  border-top-left-radius: 5px;
  background: #ffffff;
  border: 1px solid rgba(15, 23, 42, 0.08);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.03);
  animation: cleo-working-border 2.4s ease-in-out infinite;
}
@keyframes cleo-working-border {
  0%, 100% { border-color: rgba(0, 74, 173, 0.1); }
  50%      { border-color: rgba(0, 74, 173, 0.28); }
}

.cleo-working-orb {
  width: 11px;
  height: 11px;
  border-radius: 9999px;
  background: radial-gradient(circle at 32% 28%, #c9d8ee, #7f9cc7 55%, #004aad 160%);
  animation: cleo-orb-pulse 1.9s ease-in-out infinite;
}
@keyframes cleo-orb-pulse {
  0%, 100% { transform: scale(1);    box-shadow: 0 0 0 0 rgba(0, 74, 173, 0.2); }
  50%      { transform: scale(1.12); box-shadow: 0 0 0 5px rgba(0, 74, 173, 0); }
}

.cleo-working-shimmer {
  background: linear-gradient(90deg, #9aa5b6 0%, #5a769e 42%, #46648f 50%, #5a769e 58%, #9aa5b6 100%);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  animation: cleo-working-shimmer 2.6s linear infinite;
}
@keyframes cleo-working-shimmer {
  from { background-position: 200% 0; }
  to   { background-position: -200% 0; }
}

.cleo-phrase-enter-active,
.cleo-phrase-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}
.cleo-phrase-enter-from {
  opacity: 0;
  transform: translateY(5px);
}
.cleo-phrase-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
